import React from 'react';
import { connect } from 'react-redux';
import pt from 'prop-types';

import actions from 'partners/actions';
import LoadingView from 'components/view/loading';
import { VerifySignupPage } from 'partners/components/pages/signup';
import { completeSignup } from 'partners/shared/signup';

const mapStateToProps = (state) => ({
  flash: state.flash,
  lead: state.partner.lead,
});

const mapDispatchToProps = (dispatch) => ({
  fetchLead: (id) => {
    return dispatch(actions.partner.fetchLead(id));
  },

  sendLeadCode: (id) => {
    return dispatch(actions.partner.sendLeadCode(id));
  },

  completeLead(id, data) {
    return dispatch(actions.partner.completeLead(id, data));
  },

  createPartner(leadId) {
    return dispatch(actions.partner.create(leadId));
  },

  flashSuccess: (message) => {
    dispatch(actions.flash.success(message));
  },

  flashError: (message) => {
    dispatch(actions.flash.error(message));
  },
});

export class SignupVerify extends React.PureComponent {
  static propTypes = {
    lead: pt.object,
    location: pt.object,
    params: pt.object,
    router: pt.object,
    fetchLead: pt.func,
    sendLeadCode: pt.func,
    completeLead: pt.func,
    createPartner: pt.func,
    flashError: pt.func,
    flashSuccess: pt.func,
  };

  static contextTypes = {
    setTitle: pt.func.isRequired,
  };

  static onEnter() {
    window.scrollTo(0, 0);
  }

  static onChange() {
    window.scrollTo(0, 0);
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false,
      onResendEmail: this.onResendEmail.bind(this),
      onSubmitCode: this.onSubmitCode.bind(this),
    };
  }

  async UNSAFE_componentWillMount() {
    const { router, params, location, lead, fetchLead } = this.props;

    this.context.setTitle('Verify your email 📥');

    if (params.id && !lead) {
      const lead = await fetchLead(params.id);

      if (!lead) {
        router.replace('/login');
        return;
      }
    }

    // The mailed link carries the code and the lead holds the rest
    const code = location?.query?.key;

    if (code && (await this.onSubmitCode({ code }))) {
      return;
    }

    this.setState({ loaded: true });
  }

  async onResendEmail() {
    const { lead, sendLeadCode, flashSuccess, flashError } = this.props;

    const result = await sendLeadCode(lead.id);

    if (!result || result.error || result.errors) {
      flashError('Could not resend the code, please try again');
      return;
    }

    flashSuccess(`Sent email verification to ${lead.email}`);
  }

  onSubmitCode(values) {
    return completeSignup({
      ...this.props,
      leadId: this.props.params.id,
      proof: values,
    });
  }

  render() {
    if (!this.state.loaded) {
      return <LoadingView />;
    }

    return (
      <VerifySignupPage
        {...this.props}
        {...this.state}
        defaultCode={this.props.location?.query?.key}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignupVerify);
